import moment from "moment";
import { GetServerSidePropsContext } from "next";
import nookies, { parseCookies, setCookie } from "nookies";
import { wallet_provider_key } from "../config";
import { IChangePassword, ISigninInput } from "../types/auth";
import { endpointOrigin, refreshFunction } from "./apiConfig";
import { accessScope } from "../config/scope";

export const postRefreshToken = (refreshToken: string, urlOrigin?: string) => {
  const pathUrl = `${
    urlOrigin && process.env.NEXT_PUBLIC_STATE !== "development"
      ? `${urlOrigin}${endpointOrigin}`
      : endpointOrigin
  }/token`;

  let urlencoded = new URLSearchParams();
  urlencoded.append("grant_type", "refresh_token");
  urlencoded.append("refresh_token", refreshToken);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: urlencoded,
  };
  return fetch(pathUrl, options)
    .then(async (response) => {
      try {
        return { code: response.status, result: await response.json() };
      } catch (error) {
        return { code: response.status };
      }
    })
    .then((result) => {
      return result;
    })
    .catch((_error: TypeError) => {
      return { code: 500 };
    });
};

export const postRegister = (paramInput: any) => {
  return fetch(`${endpointOrigin}/account/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(paramInput),
  })
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const postSignin = (paramInput: ISigninInput) => {
  return fetch(`${endpointOrigin}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(paramInput),
  })
    .then((response) => response.json())
    .then((result) => result)
    .catch((error: TypeError) => {
      return error;
    });
};

export const logoutAPI = () => {
  const pathUrl: string = `${endpointOrigin}/logout`;
  const allCookie = parseCookies();
  const token = allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];

  const option = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return fetch(pathUrl, option)
    .then(async (response) => {
      try {
        return response.status === 401
          ? { code: response.status }
          : { code: response.status, result: await response.json() };
      } catch (error) {
        return { code: response.status };
      }
    })
    .then(async (result) => {
      if (result.code === 401) {
        const refreshToken: any = await refreshFunction(pathUrl, option);
        return refreshToken;
      } else {
        return result;
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const postChangePassword = (paramInput: IChangePassword) => {
  const allCookie = parseCookies();
  const token = allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];

  return fetch(`${endpointOrigin}/change-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      oldPassword: paramInput.oldPassword,
      newPassword: paramInput.newPassword,
    }),
  })
    .then((response) => response.status)
    .then(async (result) => {
      if (result === 401) {
        const rsRefreshToken: any = await postRefreshToken(
          allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
        );
        if (rsRefreshToken.code === 200) {
          nookies.set(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            rsRefreshToken.result.refreshToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );
          nookies.set(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            rsRefreshToken.result.accessToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );

          return fetch(`${endpointOrigin}/change-password`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${rsRefreshToken.result.accessToken}`,
            },
            body: JSON.stringify({
              oldPassword: paramInput.oldPassword,
              newPassword: paramInput.newPassword,
            }),
          })
            .then((response) => response.status)
            .then((rs) => rs)
            .catch((_error) => ({ code: 401 }));
        } else {
          nookies.destroy(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            {
              path: "/",
            }
          );
          nookies.destroy(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            { path: "/" }
          );
          nookies.destroy(null, wallet_provider_key, {
            path: "/",
          });
          return { code: 401 };
        }
      } else {
        return result;
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const callPostRefreshToken = (
  path: string,
  option: any,
  ctx?: GetServerSidePropsContext
) => {
  const cookies = ctx ? nookies.get(ctx) : parseCookies(null);
  const pathUrl = `${endpointOrigin}/token`;

  let urlencoded = new URLSearchParams();
  urlencoded.append("grant_type", "refresh_token");
  urlencoded.append(
    "refresh_token",
    cookies[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
  );
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: urlencoded,
  };
  return fetch(pathUrl, options)
    .then((response) => response.json())
    .then(async (result) => {
      if (result.accessToken && result.refreshToken) {
        if (ctx) {
          nookies.set(
            ctx,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            result.refreshToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );
          nookies.set(
            ctx,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            result.accessToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );
        } else {
          setCookie(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            result.refreshToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );
          setCookie(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            result.accessToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );
        }

        return fetch(path, {
          ...option,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${result.accessToken}`,
          },
        })
          .then((response) => response.json())
          .then((rs) => rs)
          .catch((_error) => ({ code: 401 }));
      } else {
        return { code: 401 };
      }
    })
    .catch((_error: TypeError) => {
      return { code: 401 };
    });
};

export const postVerifyConfirm = (
  code: string,
  email: string,
  urlOrigin?: string
) => {
  return fetch(
    `${
      urlOrigin ? `${urlOrigin}${endpointOrigin}` : endpointOrigin
    }/email/verify`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        code: code,
      }),
    }
  )
    .then((response) => response.status)
    .then((result) => result)
    .catch((error: TypeError) => {
      return error;
    });
};

//MING
export const postToken = (urlencoded: URLSearchParams, urlOrigin?: string) => {
  const pathUrl = `${
    urlOrigin && process.env.NEXT_PUBLIC_STATE !== "development"
      ? `${urlOrigin}${endpointOrigin}`
      : `${endpointOrigin}`
  }/login`;

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: urlencoded,
  };
  return fetch(pathUrl, options)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error: TypeError) => {
      return error;
    });
};

export const postGoogleSignin = (paramInput: any) => {
  return fetch(`${endpointOrigin}/google/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(paramInput),
  })
    .then(async (response) => {
      try {
        return { code: response.status, result: await response.json() };
      } catch (error) {
        return { code: response.status };
      }
    })
    .then((result) => result)
    .catch((error: TypeError) => {
      return error;
    });
};

export const postFacebookSignin = (paramInput: any) => {
  return fetch(`${endpointOrigin}/facebook/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(paramInput),
  })
    .then(async (response) => {
      try {
        return { code: response.status, result: await response.json() };
      } catch (error) {
        return { code: response.status };
      }
    })
    .then((result) => result)
    .catch((error: TypeError) => {
      return error;
    });
};

export const checkScope = (token?: string) => {
  const pathUrl = `${endpointOrigin}/account/application-accesses/scopes?scope=${accessScope}`;

  const option = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return fetch(pathUrl, option)
    .then(async (response) => {
      return {
        code: response.status,
        result: await response.json(),
      };
    })
    .then(async (result) => {
      if (result.code === 401) {
        const refreshToken = await refreshFunction(pathUrl, option);

        return refreshToken;
      } else {
        return { ...result, accessToken: token };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};
